import React from 'react';
import { Route, RouteComponentProps } from 'react-router-dom';

import { ReportsEdit } from './reports-edit';

function reportsEditRoute(routeProps: RouteComponentProps) {
  return (
    <Route
      path={`${routeProps.match.path}/edit/:id`}
      render={() => (
        <>
          <ReportsEdit />
        </>
      )}
    />
  );
}

export { reportsEditRoute };
